// const urlProduccion = 'https://apisolidare-11b0715ba540.herokuapp.com/api/';
const urlImages = 'https://upload.solidare.com.co/';
export default urlImages;